import React from "react";
import { convertGridToPixels } from "../../Pages/FlexibleLayout/utils";
import PositionedScreen from "../../Pages/FlexibleLayout/PositionedScreen";
import DetailsviewPreview from "../BuilderComponents/Preview/DetailsviewPreview";

const DetailsViewPreview = ({ actualConfig }) => {
  // const { allApplicationBlockData } = useAppBlocksContext();
  // if (!config || !config.id) {
  //   console.error("Invalid config provided to DetailsViewPreview", config);
  //   return <div>Error: Invalid configuration</div>;
  // }
  // const detailsView = allApplicationBlockData?.[config.id];
  // if (!detailsView) {
  //   console.error(`Details view data not found for config ID: ${config.id}`);
  //   return <div>Error: Details view data not found</div>;
  // }
  const { device, is_positioned_block, position_block_config, data: detailData, table_type } = actualConfig;

  if (!device) {
    console.error("Device type is missing in DetailsViewPreview", actualConfig);
    return <div>Error: Device type missing</div>;
  }

  try {
    if (is_positioned_block) {
      return (
        <PositionedScreen
          layoutConfig={
            device === "desktop" ? position_block_config || [] : convertGridToPixels(position_block_config || [], 4)
          }
          screenWidth={device === "desktop" ? 1600 : 512}
          type={"view"}
          tableId={detailData.table_id}
          tableType={table_type}
        />
      );
    } else {
      if (!detailData?.elements) {
        console.error("Details view elements are missing", actualConfig);
        return <div>Error: Details view elements missing</div>;
      }
      return <DetailsviewPreview detailviewConfig={detailData.elements} />;
    }
  } catch (error) {
    console.error("An error occurred while rendering DetailsViewPreview", error);
    return <div>Error: Failed to render details view preview</div>;
  }
};

export default DetailsViewPreview;
